export default "__VITE_ASSET__defb5337__"